import React, { useState, useMemo, useEffect } from "react";
import PropTypes from "prop-types";

import * as R from "ramda";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import "./css/index.scss";

const TabBar = ({ tabs, index, onTabIndexChange }) => {
  const [mount, setMount] = useState(false);
  const [tab, setTab] = useState(index);
  const titles = R.pluck("title", tabs);
  const bodies = useMemo(() => R.pluck("body", tabs), [tabs]);
  useEffect(() => {
    if (!mount) {
      // Envío evento GA visión tab de inicio y vuelta de detalle.
      onTabIndexChange(index);
      setMount(true);
    }
  }, [index, onTabIndexChange, mount]);
  return (
    <div>
      <Tabs
        value={tab}
        onChange={(_, newValue) => {
          setTab(newValue);
          onTabIndexChange(newValue);
        }}
      >
        {titles.map(title => (
          <Tab label={title} disableRipple disableFocusRipple />
        ))}
      </Tabs>
      {bodies.map((body, i) => (
        <div hidden={i !== tab} className="tab-container">
          {body}
        </div>
      ))}
    </div>
  );
};

TabBar.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({ title: PropTypes.string, body: PropTypes.node }))
    .isRequired,
  index: PropTypes.number,
  onTabIndexChange: PropTypes.func
};

TabBar.defaultProps = {
  index: 0,
  onTabIndexChange: () => {}
};

export default TabBar;
